import { useBlackfeo } from "@/hooks/use-blackfeo";
import { BlackfeoDestaque } from "@/components/blackfeo/BlackfeoPontos";
import { useEffect } from "react";
import { instalarOrigemBlack } from "@/lib/black2x1/origem-visita";
/**
 * Destaque da BLACK 2x1 2026 (mesmo visual do slide da home), com CTA para a
 * LP de captura. Some sozinho depois do fim das inscrições.
 */
import { BannerSlideView } from "@/components/home/BannerSlideView";
import { SLIDE_REGISTRY } from "@/components/home/banner-slides";

// Fim das inscrições: 03/11/2026 23h59 (horário de Brasília).
const BLACK_FIM = Date.parse("2026-11-04T02:59:59Z");

export function BlackDestaqueSection({ origem }: { origem: string }) {
  const blackfeo = useBlackfeo();
  return blackfeo ? <BlackfeoDestaque ponto={`destaque-${origem}`} /> : <BlackDobroDestaque origem={origem} />;
}

function BlackDobroDestaque({ origem }: { origem: string }) {
  useEffect(() => instalarOrigemBlack(), []);
  if (Date.now() > BLACK_FIM) return null;
  const base = SLIDE_REGISTRY.black2x1;
  if (!base) return null;
  const slide = { ...base, ctaHref: `/black-lista?ponto=destaque-${encodeURIComponent(origem)}`, ctaInternal: false };
  return (
    <section className="relative" aria-label="BLACK 2x1 2026: Pós FEO em Dobro">
      <BannerSlideView slide={slide} className="relative" compact autoHeight />
    </section>
  );
}
